<template>
    <svg class="icon">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="icon" />
    </svg>
</template>

<script>
export default {
  props: {
    icon_name: {
      type: String,
    },
  },
  computed: {
    icon() {
      return 'icons/sprite.svg#'+this.icon_name;
    },
  },
};
</script>
